import { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    // Clear all localStorage except items starting with mc_cache_
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !key.startsWith('mc_cache_')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    window.location.replace(url);
  }, [url]);

  return null;
};

export default ExternalRedirect;
